import service from "@/service.js";

function queue(config) {
  return {
    async poll(pollConfig) {
      const options = {
        maxPolls: 600,
        interval: 3000,
        ...pollConfig.options,
      };

      const queueResponse = await service(config);
      const taskId = queueResponse.data.task_id;

      for (let i = 0; i < options.maxPolls; i++) {
        if (i > 0) {
          await new Promise((resolve) => setTimeout(resolve, options.interval));
        }

        const resultUrl = pollConfig.url.replace("{taskId}", taskId);
        const resultResponse = await service({
          url: resultUrl,
          method: "get",
        });

        if (resultResponse.status === 200) {
          return resultResponse;
        }
      }

      throw new ServiceError("Task polling timeout", "POLLING_TIMEOUT_ERROR");
    },

    async pollBlob(pollConfig) {
      const options = {
        maxPolls: 600,
        interval: 3000,
        ...pollConfig.options,
      };

      const queueResponse = await service(config);
      const taskId = queueResponse.data.task_id;

      for (let i = 0; i < options.maxPolls; i++) {
        if (i > 0) {
          await new Promise((resolve) => setTimeout(resolve, options.interval));
        }

        const resultUrl = pollConfig.url.replace("{taskId}", taskId);
        const resultResponse = await service({
          url: resultUrl,
          method: "get",
          responseType: "blob",
        });

        if (resultResponse.data instanceof Blob) {
          return resultResponse;
        }
      }

      throw new ServiceError({}, "Task polling timeout", "POLLING_TIMEOUT_ERROR");
    },
  };
}

class ServiceError extends Error {
  constructor(message, code, originalError = null) {
    super(message);
    this.name = "ServiceError";
    this.code = code;
    this.originalError = originalError;
  }
}

export { queue };
